module.exports = __webpack_public_path__ + "media/images/desktop/header-bookshelf@3x-341824a1c777498c380ef7e75e75e4a1.png";